module.exports = __webpack_public_path__ + "media/images/1MBD_Vision Express-f753d5ef941bb4de75284c79c9cfe9a3.png";